import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  ${props => props.isMobile?'width: auto; margin: 0px; position: relative; flex: 1;':'width: 70px;'};
 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  > img, > p, > svg {
    margin: 0px;
  }
  &:first-of-type {
    .circleStepLine{
      display: none;
    }
  }
  svg {
    height: 32px;
  }
  svg, p {
    color: ${props => props.theme.colors.black};
  }
  &.completed{
    .circleStepWrapper{
      .circleStep{
        border: 1px solid #5095BF;
        background: #5095BF;
      }
    }
  }
  &.active {
    svg, p {
      color: ${props => props.theme.colors.blue};
    }
    .circleStepWrapper{
      .circleStep{
        border: 1px solid #5095BF;
        > div{
          background: #5095BF;
        }
      }
    }
  }
  &.error {
    svg, p {
      color: ${props => props.theme.colors.error};
    }
  }
  &:hover {
    svg, p {
      color: ${props => props.theme.colors.blue};
    }
  }
  &.error:hover {
    svg, p {
      color: ${props => props.theme.colors.error};
    }
  }
  .circleStepWrapper{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .circleStep{
      border: 1px solid gray;
      border-radius: 50%;
      > div{
        margin: 5px;
        padding: 5px;
        // background: blue;
        border-radius: 50%;
      }
    }
    .circleStepLine{
      min-width: 15px;
      border-top: 1px solid gray;
      position: absolute;
      left: calc(-50% + 12px);
      right: calc(50% + 12px);
    }
  }

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    p {
      display: none;
    }
    svg {
      height: 24px;
    }
  }
`;

const StepperButton = props => {
  const { metaData, handleClick, isDisabled, isActive, isError, isMobile, isCompleted } = props;
  const Icon = metaData ? metaData.icon : null;
  const classes = [];
  classes.push(isActive ? 'active' : isError ? 'error' : '');
  classes.push(isCompleted?"completed":'');
  return (
    <Wrapper
      onClick={handleClick}
      isActive={isActive}
      className={classes.join(" ")}
      isMobile={isMobile}
    >
      {isMobile ? (
        <div className='circleStepWrapper'>
          <div className='circleStep'>
              <div></div>
          </div>
          <div className='circleStepLine'>
            <div className='lineee'></div>
          </div>
        </div>
      ) : (
        <>
          {Icon && <Icon />}
          {metaData.text && <p>{metaData.text}</p>}
        </>
      )}
    </Wrapper>
  );
};

export default StepperButton;